// Libraries
import _get from "lodash/get";
import { getEnvironments } from "../helpers/Meet";
import { store } from "../store";

// Routes
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    redirect: "/"
  },
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home"),
    beforeEnter(to, from, next) {
      if (_get(to, "query.pr")) next({ name: "Decoder", query: to.query });
      else next({ name: "SelfService" });
    }
  },
  {
    path: "/simulator",
    name: "Simulator",
    component: () => import("../views/simulator.vue")
  },
  {
    path: "/recorder",
    name: "Recorder",
    component: () => import("../views/Recorder.vue")
  },
  {
    path: "/turn_assigner/:turnId?",
    name: "TurnAssigner",
    component: () => import("../views/TurnAssigner.vue")
  },
  {
    path: "/meeting/:meetId?",
    name: "Meeting",
    component: () => import("../views/MeetingWrapper.vue")
  },
  {
    path: "/meeting_direct/:meetId?",
    name: "MeetingDirect",
    component: () => import("../views/MeetingDirect.vue")
  },
  {
    path: "/agent",
    component: () => import("../views/Agent.vue"),
    children: [
      {
        path: "",
        name: "Agent",
        component: () => import("../views/AgentBase.vue")
      },
      {
        path: ":meetId",
        name: "MeetingAgent",
        component: () => import("../views/MeetingWrapper.vue")
      }
    ]
  },
  {
    path: "/silver",
    component: () => import("../views/Agent.vue"),
    children: [
      {
        path: "",
        name: "AgentSilver",
        component: () => import("../views/silver/AgentSilver")
      }
    ]
  },
  {
    path: "/out_of_service",
    name: "OutService",
    component: () => import("../views/OutOperations")
  },
  {
    path: "/before-turn",
    name: "BeforeTurn",
    component: () => import("../views/BeforeTurn.vue"),
    props: true
  },
  {
    path: "/turno",
    name: "Turno",
    component: () => import("../views/Turno.vue"),
    props: true
  },
  {
    path: "/canceled",
    name: "Canceled",
    component: () => import("../views/Canceled.vue")
  },
  {
    path: "/canceled_agent",
    name: "CanceledAgent",
    component: () => import("../views/Canceled_agent.vue")
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/ProfilePM.vue")
  },
  {
    path: "/profile_dev",
    name: "Profile_dev",
    component: () => import("../views/Profile.vue")
  },
  {
    path: "/dc",
    name: "Decoder",
    component: () => import("../views/Decoder.vue")
  },
  {
    path: "/ad",
    component: () => import("../views/components/TypicalRoot"),
    children: [
      {
        path: "",
        name: "SelfService",
        component: () => import("../views/autoservice/root")
      }
    ]
  },
  {
    path: "/fv/:code?",
    name: "Virtualrow",
    component: () => import("../views/virtualrow/root")
  },
  {
    path: "/fv_atril/:code?",
    name: "VirtualrowAtril",
    component: () => import("../views/virtualrow/root")
  },
  {
    path: "/fv_print",
    name: "TicketPrint",
    component: () => import("../views/virtualrow/TicketPrint")
  },
  {
    path: "/fv_print_pay",
    name: "InfoPrint",
    component: () => import("../views/virtualrow/InfoPrint")
  },
  {
    path: "/environment_error",
    name: "EnvironmentError",
    component: () => import("../views/EnvironmentError")
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach(async (to, from, next) => {
  try {
    await getEnvironments();
    store.dispatch("log/put", {
      name: "Router. Variables de entorno obtenidas"
    });
    next();
  } catch (error) {
    store.dispatch("log/put", {
      name: "Router. Error bloqueante. No se obtienen las variables de entorno",
      checked: false,
      message: error
    });
    console.error("Error with environment variables", error);
    next("/environment_error");
  }
});

export default router;
